import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import CrashBoundary from './components/common/CrashBoundary';
import reportWebVitals from './reportWebVitals';
import { seedPublicProduct } from './utils/publicBootstrap';
import { installApiFailureWatch } from './utils/apiStatus';

// staleTime long enough that a hover-prefetch a few seconds before a click
// isn't wasted — product detail data doesn't change moment-to-moment.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
  },
});

seedPublicProduct(queryClient);

// "We'll be back shortly": checks the API only after a request to it fails.
installApiFailureWatch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Last line of defence: a crash in the shell itself shows a message
        and a Reload button, never a blank page. */}
    <CrashBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </CrashBoundary>
  </React.StrictMode>
);

// Real visitors' LCP, INP and CLS, to our own consent-gated analytics
// (src/reportWebVitals.js).
reportWebVitals();
